import axios from "axios";
import { constructAndReturnValidationErrorMessage } from "./PreviewUtils";

const APIENDPOINT = process.env.REACT_APP_HOST;

export const fetchCampaignData = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/campaigns`, {
      headers: {
        Authorization: bearerToken,
      },
    });
    switch (response.status) {
      case 200:
        const data = await response.data;
        return data;

      case 400:
        return null;

      case 404:
        return null;

      case 500:
        return null;

      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

export const fetchExistingCampaigns = async (bearerToken) => {
  let message;
  try {
    const response = await axios.get(`https://${APIENDPOINT}/campaigns`, {
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status < 500,
    });

    switch (response.status) {
      case 200:
        const data = await response.data;
        return {
          success: true,

          data: data.records,
        };

      case 404:
        message = "No campaigns exist for this user currently";

        return {
          success: false,
          error: message,
        };

      default:
        message =
          "Something went wrong while attempting to display data on the screen.";
        return {
          success: false,
          error: message,
        };
    }
  } catch (error) {
    message =
      "Something went wrong while attempting to display data on the screen.";
    return {
      success: false,
      error: message,
    };
  }
};
export const createCampaign = async (payload, bearerToken) => {
  const response = await axios.post(
    `https://${APIENDPOINT}/campaigns`,
    payload,
    {
      headers: {
        Authorization: bearerToken,
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status <= 500,
    }
  );
  return response;
};

export const uploadContactsToAPI = async (csvFile, payload, bearerToken) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) =>
    formData.append(key, value)
  );
  formData.append("file", csvFile);

  try {
    const response = await axios.post(`https://${APIENDPOINT}/bulk`, formData, {
      headers: {
        Authorization: bearerToken,
        "Content-Type": "multipart/form-data",
      },
      validateStatus: (status) => status <= 500,
    });

    if (response.status === 200) {
      return {
        success: true,
        message: "Contacts uploaded successfully",
        data: response.data,
      };
    }
    return {
      success: false,
      message: response.data?.message || "Unexpected error occurred",
    };
  } catch (err) {
    return {
      success: false,
      message: "Upload failed. Please contact support.",
    };
  }
};

export const saveCustomizationToDB = async (data, bearerToken) => {
  try {
    const response = axios.post(
      `https://${APIENDPOINT}/templates`,

      {
        form_data: data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: bearerToken,
        },
        validateStatus: (status) => status <= 500,
      }
    );
    return response;
  } catch (error) {
    return response;
  }
};
export const getCustomizedTemplatesCreatedByUser = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/templates`, {
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status < 500,
    });
    switch (response.status) {
      case 200:
        const templatesData = await response.data;
        return templatesData.records;
      case 400:
        return {};
      case 404:
        return {};
      default:
        return {};
    }
  } catch (error) {
    return {};
  }
};

export const requestForPDFGeneration = async (
  campaign,
  template,
  bearerToken
) => {
  try {
    const response = await axios.post(
      `https://${APIENDPOINT}/requests`,
      {
        campaign: campaign,
        template: template,
      },

      {
        headers: {
          Authorization: bearerToken,
        },
        timeout: 30000,
        validateStatus: (status) => status < 500,
      }
    );
    switch (response.status) {
      case 201:
        return {
          success: true,
          message: "Your request to 'Generate Print Collaterals' is accepted.\nIt will take some time to process your request.\nYou can refresh the grid to see the status of your request.",
          data: response.data,
        };
      case 409:
        return {
          success: false,
          error:
            "Request with the same values is already created. Please download the file from the grid when it is complete",
        };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const fetchPdfGenerationRequestsForCustomer = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/requests`, {
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status < 500,
    });
    switch (response.status) {
      case 200:
        const data = await response.data;
        return data;
      case 404:
        return response.data;
    }
  } catch (error) {
    return error.message;
  }
};

export const fetchCampaigns = async (BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/campaigns`, {
    headers: {
      Authorization: BEARER,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  });
};

export const fetchRespondedContacts = async (campaignName, BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/records`, {
    headers: {
      Authorization: BEARER,
    },
    params: {
      campaign: campaignName,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  });
};

export const fetchContactVisits = async (trackable, BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/related`, {
    params: {
      path: trackable,
    },
    headers: {
      Authorization: BEARER,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  });
};

export const fetchUsersFromDB = async (BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/users`, {
    headers: {
      Authorization: BEARER,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  });
};

export const createUser = async (name, email, phone, BEARER) => {
  try {
    const response = await axios.post(
      `https://${APIENDPOINT}/users`,
      { name, email, phone },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: BEARER,
        },
        validateStatus: (status) => status >= 200 && status <= 500,
      }
    );

    if (response.status === 201) {
      const data = response.data;
      return {
        success: true,
        message: `An account for email ${data.details.email} has been created successfully. Associated customer ID is ${data.details.customer_id}`,
      };
    } else if (response.status === 400) {
      return {
        success: false,
        message: `User with email ${email} already exists.Please use a different email address.`,
      };
    } else if (response.status === 500) {
      return {
        success: false,
        message: `The operation you attempted has failed. Please contact support.`,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: `A network request exception occurred`,
    };
  }
};

export const generatePreviewPdf = async (formData, BEARER) => {
  try {
    const response = await axios.post(
      `https://${APIENDPOINT}/preview`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
           Authorization: BEARER,
        },
        responseType: "arraybuffer",

        validateStatus: (status) => status >= 200 && status <= 500,
      }
    );

    if (response.status === 200) {
      const data = response.data;

      return {
        success: true,
        data: data,
      };
    } else if (response.status === 400) {
      const decoder = new TextDecoder("utf-8");
      const responseText = decoder.decode(response.data);
      const responseJson = JSON.parse(responseText);
      if (responseJson.errors && responseJson.errors.length > 0) {
        const errorMessage = responseJson.errors[0].qrCodeContent;
        return {
          success: false,
          message: errorMessage,
        };
      }
      return {
        success: false,
        message: rawMessage,
      };
    } else if (response.status === 422) {
      const decoder = new TextDecoder("utf-8");
      const responseText = decoder.decode(response.data);
      const responseJson = JSON.parse(responseText);
      const rawMessage = responseJson.message || "[]";
      const messageContent =
        "Your attempt to create a campaign failed due to invalid inputs that were found while validating it";
      const constructedErrorMessage = constructAndReturnValidationErrorMessage(
        rawMessage,
        messageContent
      );
      return {
        success: false,
        message: constructedErrorMessage,
      };
    } else if (response.status === 500) {
      return {
        success: false,
        message:
          "The operation you attempted has failed. Please contact support.",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        "The operation you attempted has failed. Please contact support.",
    };
  }
};
